module.exports = __webpack_public_path__ + "static/vf_wpaddings_core.57bbdb14.svg";